import React from 'react'
import { RiArrowLeftDoubleLine, RiArrowRightDoubleLine } from 'react-icons/ri';

const Pagination = ({ postsPerPage, totalPosts, currentPage, setCurrentPage }) => {
    const pageNumber = [];

    for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
        pageNumber.push(i)
    }

    const prePage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    const nextPage = () => {
        if (currentPage !== postsPerPage) {
            setCurrentPage(currentPage + 1)
        }
    }

    return (
        <nav className='w-full flex justify-center mb-2'>
            <ul className='flex flex-row'>
                {currentPage === 1 ?
                    null
                    :
                    <li onClick={prePage} className='border border-blue-400 m-1 px-2 rounded flex items-center text-blue-500'>
                        <RiArrowLeftDoubleLine />
                    </li>
                }
                {pageNumber.map(number => {
                    return (
                        <li
                            onClick={() => setCurrentPage(number)}
                            key={number}
                            className={`border border-blue-400 m-1 px-2 rounded
                                       ${currentPage === number ? "bg-blue-400" : null}
                                        `}
                        >
                            {number}
                        </li>
                    )
                })}
                {currentPage === postsPerPage ?
                    null
                    :
                    <li onClick={nextPage} className='border border-blue-400 m-1 px-2 rounded flex items-center text-blue-500'>
                        <RiArrowRightDoubleLine />
                    </li>
                }
            </ul>
        </nav>
    )
}
export default Pagination;